<template>
  <div>
    <component
      :is="component"
    />
  </div>
</template>
<script>
import Func18RevistasManuais from '@/views/18/Func18RevistasManuais.vue'

export default {
  name: 'Func18',
  data () {
    return {
      component: Func18RevistasManuais
    }
  }
}
</script>
